enum Status {
  ACTIVE = 'active',
  UPCOMING = 'upcoming',
  ENDED = 'ended'
}

export default Status
